import { cn } from "../utils/cn";

type BadgeProps = {
  label: string;
  tone?: "neutral" | "success" | "warning" | "danger";
  state?: "default" | "loading";
};

export function Badge({ label, tone = "neutral", state = "default" }: BadgeProps) {
  const tones = {
    neutral: "text-muted border-border bg-surface-subtle",
    success: "text-success border-success/30 bg-success/10",
    warning: "text-warning border-warning/30 bg-warning/10",
    danger: "text-danger border-danger/30 bg-danger/10",
  };
  return (
    <span className={cn("rounded-full border px-2 py-1 text-xs font-medium", tones[tone])}>
      {state === "loading" ? "Chargement" : label}
    </span>
  );
}
